import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { complaintsApi } from '../../services/api'
import TableActionButton from '../../components/TableActionButton'

const PRIORITY_LABELS: Record<string, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
}

const COMPLAINT_STATUS_LABELS: Record<string, string> = {
  open: 'Abierta',
  in_progress: 'En Progreso',
  resolved: 'Resuelta',
  closed: 'Cerrada',
}

export default function ComplaintsPage() {
  const [complaints, setComplaints] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchComplaints()
  }, [])

  const fetchComplaints = async () => {
    try {
      const response = await complaintsApi.list()
      setComplaints(response.data.complaints || [])
    } catch (error) {
      console.error('Error fetching complaints:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleResolve = async (id: number) => {
    try {
      await complaintsApi.resolve(id, { resolution_notes: 'Resuelto por administrador' })
      toast.success('Queja resuelta')
      fetchComplaints()
    } catch (error: any) {
      console.error('Error resolving complaint:', error)
      toast.error(error.response?.data?.error || 'Error al resolver la queja')
    }
  }

  if (loading) {
    return <div className="text-center py-8">Cargando...</div>
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-espresso-800 mb-6">Gestión de Quejas</h1>

      <div className="bg-cream-50 shadow rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-espresso-100">
          <thead className="bg-cream-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Asunto
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Vendedor
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Cliente
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Categoría
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Prioridad
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Estado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Creado
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-espresso-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-cream-50 divide-y divide-espresso-100">
            {complaints.map((complaint) => (
              <tr key={complaint.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-espresso-800">
                  {complaint.subject}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-espresso-800">
                  {complaint.seller_name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-espresso-500">
                  {complaint.customer_name || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-espresso-500">
                  {complaint.category || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      complaint.priority === 'high'
                        ? 'bg-red-100 text-red-800'
                        : complaint.priority === 'medium'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-green-100 text-green-800'
                    }`}
                  >
                    {PRIORITY_LABELS[complaint.priority] || complaint.priority}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      complaint.status === 'resolved'
                        ? 'bg-green-100 text-green-800'
                        : complaint.status === 'in_progress'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-red-100 text-red-800'
                    }`}
                  >
                    {COMPLAINT_STATUS_LABELS[complaint.status] || complaint.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-espresso-500">
                  {new Date(complaint.created_at).toLocaleDateString()}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  {complaint.status !== 'resolved' && (
                    <TableActionButton
                      onClick={() => handleResolve(complaint.id)}
                      variant="success"
                    >
                      Resolver
                    </TableActionButton>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        {complaints.length === 0 && (
          <div className="text-center py-8 text-espresso-500">No hay quejas registradas aún.</div>
        )}
      </div>
    </div>
  )
}
